import featureDark from '../../feature/dark';

const dark = (params) => featureDark(params);

export default dark;
